import React, { useState, useEffect } from 'react';
import { IoLogoGooglePlaystore } from 'react-icons/io5';
import { Link, useNavigate } from 'react-router-dom';

export default function Services() {
  const navigate = useNavigate();
  const [visibleSections, setVisibleSections] = useState(new Set());

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    {
      title: 'Download Media Promosi',
      icon: '/images/panduan/download.jpg',
      desc: 'Download Banner Usaha Konter dihalaman ini.',
      gradient: 'from-blue-600 to-cyan-600',
      link: '/media-promosi',
      features: ['Banner Daftar Harga', 'Banner Melayani Transaksi', 'Kartu Nama Agen', 'Tutorial Penggunaan Aplikasi']
    },
    {
      title: 'Panduan Aplikasi',
      icon: '/images/panduan/phone.jpg',
      desc: 'Klik disini agar Kamu tahu cara menggunakan Aplikasi Kenzie Komunika APK',
      gradient: 'from-red-600 to-pink-600',
      link: '/panduan-aplikasi',
      features: ['Panduan Cara Daftar', 'Panduan Cara Login', 'Cara Transaksi', 'Cara Bayar Tagihan', 'Cara Aktivasi Voucher', 'Cara Memasukkan Kode Referal', 'Cara Daftarkan Downline', 'Cara Binding Dompet Digital']
    },
    {
      title: 'Panduan Daftar QRISku',
      icon: '/images/panduan/qr.jpg',
      desc: 'Daftarkan outlet / toko kamu dengan pembayaran via QRIS di Kenzie Komunika APK',
      gradient: 'from-purple-600 to-blue-600',
      link: '/panduan-daftar-qrisku',
      features: ['Cara Daftar', 'Persyaratan', 'Proses Pendaftaran', 'FAQ']
    }
  ];

  return (
    <div className="min-h-screen bg-slate-100/95 text-slate-700">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 pt-40 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-panduan.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-50"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${
          visibleSections.has('header') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274]  bg-clip-text text-transparent">
            Panduan Registrasi Kenzie Komunika
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-[#3E3274] mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Bergabung menjadi mitra Kenzie Komunika sangat mudah dan cepat. Kami menyediakan beberapa metode pendaftaran yang fleksibel untuk memudahkan Anda memulai bisnis, baik melalui SMS, WhatsApp, maupun aplikasi Android resmi kami.
            <br/>
            <span className='font-bold'>Kenzie Komunika - The best choice for online & payment products.</span>
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section 
        data-section="services"
        className="py-10 bg-white"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('services') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index} onClick={() => navigate(service.link)}
                className="cursor-pointer group relative p-8 bg-white backdrop-blur-sm rounded-2xl border border-slate-700 hover:border-transparent transition-all duration-500 transform hover:scale-105 hover:-translate-y-2"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-500`}></div>
                <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-20 blur-xl transition-opacity duration-500`}></div>
                
                <div className="relative z-10">
                  <div className="text-5xl mb-4 transform group-hover:scale-110 transition-transform duration-300">
                    <img
                      src={service.icon}
                      className='h-24 rounded-xl'
                    />
                  </div>
                  <h3 className="text-2xl font-bold mb-3 text-slate-700 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-gray-100 group-hover:bg-clip-text transition-all duration-300">
                    {service.title}
                  </h3>
                  <p className="text-gray-400 group-hover:text-white transition-colors duration-300 mb-4">
                    {service.desc}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-gray-500 group-hover:text-white transition-colors duration-300">
                        <span className="w-1.5 h-1.5 bg-red-500 hover:bg-white rounded-full mr-2"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      {/* <section 
        data-section="process"
        className="py-24 bg-gradient-to-b from-slate-950 to-slate-900"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-300 ${
          visibleSections.has('process') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="text-center mb-16">
            <h2 className="font-bricolage text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
              Pendaftaran Radar Pulsa
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-4"></div>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Berikut adalah referensi tabel daftar kode referral
            </p>
          </div> */}

            {/* {[
          <div className="grid md:grid-cols-4 gap-8">
              { step: '01', title: 'Discovery', desc: 'Understanding your needs and goals', icon: '🔍' },
              { step: '02', title: 'Planning', desc: 'Strategizing the best approach', icon: '📋' },
              { step: '03', title: 'Development', desc: 'Building your solution with care', icon: '⚙️' },
              { step: '04', title: 'Launch', desc: 'Deploying and supporting your project', icon: '🚀' },
            ].map((phase, index) => (
              <div
                key={index}
                className="relative group"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="text-center p-6 bg-slate-800/30 backdrop-blur-sm rounded-xl border border-slate-700 hover:bg-slate-800/50 transition-all duration-300 transform hover:scale-105">
                  <div className="text-6xl mb-4 opacity-20 font-bold bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
                    {phase.step}
                  </div>
                  <div className="text-4xl mb-4 transform group-hover:scale-110 transition-transform duration-300">
                    {phase.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-white">{phase.title}</h3>
                  <p className="text-gray-400 text-sm">{phase.desc}</p>
                </div>
                {index < 3 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                    <svg className="w-8 h-8 text-blue-500/30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                )}
              </div>
          </div>
            ))} */}
          {/* <div class="rounded-lg border border-gray-200 max-w-7xl transition-all duration-1000 delay-300">
            <table class="min-w-full divide-y divide-gray-200 bg-gradient-to-b from-slate-900 to-slate-950 text-2xl text-gray-400 ">
              <thead class="font-bricolage font-bold mb-4 bg-gradient-to-r from-blue-400 to-red-400  text-transparent">
                <tr>
                  <th class="p-4 font-medium text-gray-900 text-center">ID MK</th>
                  <th class="p-4 font-medium text-gray-900 text-center">Nama MK</th>
                  <th class="font-medium text-gray-900 text-center">Kode Refferal</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <tr class="hover:bg-gray-500">
                  <td class="p-4  text-white text-center">MK001</td>
                  <td class="p-4 text-white text-center">Radar Pulsa</td>
                  <td class="p-4 text-white text-center">RADARPULSA</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section> */}

      {/* Technologies Section */}
      <section 
        data-section="tech"
        className="py-24 bg-slate-100/95 text-slate-700"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-400 ${
          visibleSections.has('tech') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="text-center mb-16">
            <h2 className="font-bricolage text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent">
              Download Aplikasi Kenzie Komunika APK
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-[#3E3274] mx-auto mb-4"></div>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Transaksi mudah melalui Kenzie Komunika APK.
            </p>
          </div>

          <div className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 `}>
            <Link 
              to="/contact"
              className="inline-block px-10 py-4 bg-gradient-to-r from-red-500 to-[#3E3274] rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-125 transition-all duration-300"
            >
              <div className='flex flex-row gap-6 text-white items-center'>
                <IoLogoGooglePlaystore size={25}></IoLogoGooglePlaystore> Kenzie Komunika APK
              </div>
            </Link>
          </div>
        </div>
      </section>

      
    </div>
  );
}
